import { createContext } from "react";

/**
 * Context that provides a function to set the work packet ID to view in a popup.
 * Passing `null` should close the popup.
 */
export const WorkPacketPopupContext = createContext((workPacketId: string | null) => {
  console.error(`Tried to open work packet ${workPacketId} without a parent WorkPacketPopupContext`);
});
